import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function topicsCarousel() {
	new Swiper('.swiper.topics', {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 20,
		loop: true,
		createElements: true,

		navigation: {
			enabled: true,
		},

		breakpoints: {
			1024: {
				slidesPerView: '3',
			},
			768: {
				slidesPerView: '2',
			}
		}
	});
}
